export const iconFontAwesomeMapsBookAtlas = (
	<i className="fa-solid fa-book-atlas"></i>
);
